import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  type IConfig,
  type IConfiguration,
} from "@microsoft/applicationinsights-web";

export const reactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights | undefined;

export function configureAppInsights(connectionString: string) {
  if (
    appInsights ||
    process.env.NODE_ENV !== "production" ||
    !connectionString
  ) {
    return;
  }
  const config: IConfiguration & IConfig = {
    connectionString,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  };
  try {
    const insights = new ApplicationInsights({ config });
    insights.loadAppInsights();
    appInsights = insights;
  } catch {
    console.error("failed to load appInsights");
  }
}
